// plan-13 S02: canonical alias pool — 96 Oracle-toned aliases
// strict canon: no real handles, no marketing words, no emoji, all lowercase + dot-or-dash

export const ALIAS_POOL: string[] = [
  'node-04', 'node-12', 'node-23', 'node-48', 'node-07',
  'node-19', 'node-33', 'node-47', 'node-01', 'node-16',
  'node-31', 'node-42', 'node-08', 'node-27', 'node-39',
  'node-11', 'node-44', 'node-06', 'node-28', 'node-15',
  'pa.observer', 'cursor.silent', 'lambda.0', 'quorum.7',
  'proposal.null', 'signal.dim', 'vector.04', 'gradient.48',
  'epoch.0', 'seal.k', 'gateway.7e', 'relay.96',
  'drift.48', 'router.04', 'kernel.1', 'hash.null',
  'observer.9', 'consensus.0', 'node.watch', 'packet.48',
  'freq.048', 'sync.48', 'pulse.04', 'wave.96',
  'pattern.7', 'oracle.dim', 'feed.048', 'stream.null',
  'mesh.48', 'grid.04', 'trace.48', 'scan.048',
  'probe.0', 'beacon.48', 'anchor.04', 'lock.null',
  'matrix.48', 'phase.04', 'cycle.48', 'loop.048',
  'wire.48', 'link.04', 'bond.48', 'chain.048',
  'core.0', 'edge.48', 'ring.04', 'shell.null',
  'depth.48', 'layer.04', 'strata.48', 'level.048',
  'map.48', 'zone.04', 'cell.48', 'grid.null',
  'port.048', 'gate.48', 'path.04', 'route.48',
  'hub.048', 'bridge.48', 'span.04', 'arc.48',
  'mirror.0', 'echo.48', 'shadow.04', 'ghost.48',
  'cipher.0', 'codec.48', 'parse.04', 'token.48',
  'ledger.0', 'log.48', 'record.04', 'archive.48',
]

// 96 aliases total
